import React, { useEffect } from 'react';
import { PianoAdvertorial } from './pages/PianoAdvertorial';
declare global {
  interface Window {
    fbq: any;
  }
}
export function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    script.onload = () => {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
      window.fbq('init', '25771694632496569');
      window.fbq('track', 'PageView');
    };
  }, []);
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <PianoAdvertorial data-id="element-1" />
    </div>;
}